import { getApiClient } from '@aslanpay/portal-common-lib';

/**
 * Get the API client instance that handles authentication automatically
 * This uses the same authentication mechanism as portal-common-lib services
 */
const getAuthenticatedApiClient = () => {
  return getApiClient();
};

export default getAuthenticatedApiClient;
